import {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'

const CHECKED_ID = 'checked'
const UNCHECKED_ID = 'unchecked'

const FormReservation = ({onChange, type, value, wrapper}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const {FILTERS_GROUPS_IDS} = config.get('filtersGroups')

  const _handleChange = (e, {checked}) => {
    onChange(e, {
      field: FILTER_NAMES.HAS_RESERVATION,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.HAS_RESERVATION],
      value: checked
    })
  }

  const handleChange = ({value: selectedValue}) => {
    const [currentValue] = selectedValue
    _handleChange(null, {checked: currentValue === CHECKED_ID})
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          name: FILTER_NAMES.HAS_RESERVATION,
          options: [{id: CHECKED_ID, label: i18n.t('FILTER.HAS_RESERVATION.LABEL')}],
          type
        }
      ]}
      group={FILTERS_GROUPS_IDS.ONLINE_SERVICES_GROUP_ID}
      helpText={i18n.t('FILTER.HAS_RESERVATION.HELP_TEXT')}
      legend={i18n.t('FILTER.HAS_RESERVATION.LABEL')}
      onChange={handleChange}
      value={{[FILTER_NAMES.HAS_RESERVATION]: [value ? [CHECKED_ID] : [UNCHECKED_ID]]}}
      wrapper={wrapper}
    />
  )
}

FormReservation.displayName = 'FormReservation'
FormReservation.propTypes = {
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  value: PropTypes.number,
  wrapper: PropTypes.string
}
const FormReservationMemo = memo(FormReservation)
FormReservationMemo.displayName = 'FormReservation'

export default FormReservationMemo
